// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3K98Q","messages":"Chat_messages__3B3De","dateDivider":"Chat_dateDivider__2QJuD"};